import { type RouteLocationNormalized } from 'vue-router';

export type RouteWithQuery = Pick<RouteLocationNormalized, 'query'>;

export function isFeatureEnabled(key: SupportedFeatures, route: RouteWithQuery): boolean {
  const featuresFromRoute = getFeaturesFromRoute(route);

  return featuresFromRoute.includes(key);
}

function getFeaturesFromRoute(route: RouteWithQuery): string[] {
  // Vue Router yields an array when a query key is repeated (?feature=a&feature=b).
  const features = route?.query?.feature ?? '';

  return (Array.isArray(features) ? features : [features])
    .flatMap((value) => String(value ?? '').split(','))
    .map((feature) => feature.trim());
}

export enum SupportedFeatures {
  DEACTIVATE_REASON_MDOAL = 'useDeactivateReasonModal',
  PERFORMANCE_SCORE_SORTING = 'performanceScoreSorting',
  AI_DIAGNOSIS = 'aiDiagnosis',
  EXPERIMENTAL_TOPLISTING_PRICES = 'experimentalToplistingPrices',
  ENABLE_WINNING_MANDATE = 'enableWinningMandate',
  RH_SLOT_MANAGEMENT = 'rhSlotManagement',
  PRICE_DROP_ALERT = 'priceDropAlert',
}
